const trim = (value = "") => String(value).trim();
const trimSlash = (value = "") => trim(value).replace(/\/+$/, "");

const toAbsoluteUrl = (path) => {
  const value = trim(path);
  if (!value) return "";
  if (/^https?:\/\//i.test(value)) return value;
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  return `${origin}${value.startsWith("/") ? value : `/${value}`}`;
};

const rawApi = trimSlash(
  process.env.REACT_APP_API_URL || "http://localhost:8000/api",
);
const rawMedia = trimSlash(
  process.env.REACT_APP_MEDIA_URL || "http://localhost:8000",
);

export const API_URL = rawApi;
export const MEDIA_URL = rawMedia.endsWith("/media")
  ? rawMedia
  : `${rawMedia}/media`;
export const HOSPITAL_NAME = trim(
  process.env.REACT_APP_HOSPITAL_NAME || "فارمسی ابن سینا ۳۰ نمبر دیپو",
);
export const HOSPITAL_ADDRESS = trim(
  process.env.REACT_APP_HOSPITAL_ADDRESS ||
    "Afghan Cosmos Group, Kabul, Afghanistan",
);
export const HOSPITAL_PHONES = [
  trim(process.env.REACT_APP_HOSPITAL_PHONE || "0764410453"),
  trim(process.env.REACT_APP_HOSPITAL_PHONE_2 || "0783344594"),
].filter(Boolean);
export const HOSPITAL_PHONE = HOSPITAL_PHONES.join(" | ");
export const LOGO_PATH =
  process.env.REACT_APP_LOGO_URL || "/images/logo/logo.png";
export const LOGO_URL = toAbsoluteUrl(LOGO_PATH);
export const FAVICON_PATH = LOGO_PATH.replace(/^https?:\/\/[^/]+/i, "") || LOGO_PATH;
export const BACKGROUND_URL = `${MEDIA_URL}/images/background/1.jpg`;
export const flagUrl = (file) => `${MEDIA_URL}/images/flags/${file}`;
